import React, { useCallback } from 'react';
import './Slider.css';

/**
 * Slider component with 3 variants:
 * - 'full': Label + min/max + value display (for forms like CreateGame)
 * - 'compact': Just the input with styled thumb/track (for ConfigModal)
 * - 'mini': Small width input (for speed controls)
 */
const Slider = React.memo(({
  value,
  onChange,
  min,
  max,
  variant = 'full',
  label,
  id,
  step = 1,
  disabled = false,
  className = '',
}) => {
  const handleChange = useCallback((e) => {
    const numericValue = Number(e.target.value);
    onChange(numericValue);
  }, [onChange]);

  const inputClasses = `slider-input slider-input--${variant} ${disabled ? 'slider-input--disabled' : ''} ${className}`.trim();

  // Compact and mini: just the input
  if (variant === 'compact' || variant === 'mini') {
    return (
      <input
        id={id}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={inputClasses}
        aria-label={label || `Slider from ${min} to ${max}`}
      />
    );
  }

  // Full variant: label + min/max + value display
  return (
    <div className="slider-wrapper">
      {label && <label htmlFor={id} className="slider-label">{label}:</label>}
      <div className="slider-container">
        <span className="slider-min">{min}</span>
        <input
          id={id}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          className={inputClasses}
          aria-label={label || `Slider from ${min} to ${max}`}
        />
        <span className="slider-max">{max}</span>
      </div>
      <div className="slider-value-display">{value}</div>
    </div>
  );
});

Slider.displayName = 'Slider';

export default Slider;
